import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const location = useLocation(); // Hook to get the current location

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location]); // This hook runs every time the location changes

  return null; // This component doesn't render anything, it just triggers the scroll
}

export default ScrollToTop;
